var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-layout-box p-custom-message"},[_c('list-view',{attrs:{"getList":_vm.getList,"isTabsShow":_vm.isTabsShow,"isButtonShow":_vm.isButtonShow,"isSearchShow":_vm.isSearchShow,"listMap":_vm.listMap}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }